exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".main-remind{width:100%;max-width:400px;margin:0 auto}", "", {"version":3,"sources":["/home/webuser/miles/releases/159/spa/src/pages/auth/remindPassword/RemindPassword.scss"],"names":[],"mappings":"AAAA,aACE,WACA,gBACA,aAAA,CAAA","file":"RemindPassword.scss?vue&type=style&index=0&prod&lang=scss&","sourcesContent":[".main-remind {\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);

// exports
